<ng-container *ngIf="customFields$ | async; let customFields">
    <div *ngIf="customFields && customFields.length > 0" class="row">
        <div *ngFor="let customField of customFields" [ngClass]="columnSize" class="mb-3">
            <label class="small font-weight-bold m-0">{{ customField.display_name }}</label>
            <div
                *ngIf="dateFormat$ | async; let date_format"
                [innerHTML]="customField | customFieldValue: date_format | lineBreaks">
            </div>
        </div>
    </div>
</ng-container>
